module.exports = __webpack_public_path__ + "static/media/intro.efc1a09a.png";